<app-titulo texto="Agendamento para Atendimento Presencial"></app-titulo>
<div class="w-full text-sm font-opensans text-700">
  <div>
    <p>
      <b
        >VERIFIQUE ABAIXO COMO EST&Aacute; FUNCIONANDO O ATENDIMENTO PRESENCIAL
        DA CASAN EM SEU MUNIC&Iacute;PIO:</b
      >
    </p>
    <ul>
      <li>
        Ag&ecirc;ncias de <b>Bigua&ccedil;u e Crici&uacute;ma</b> o atendimento
        poder&aacute; ser realizado atrav&eacute;s de agendamento ou por ordem
        de chegada com a retirada de senhas;
      </li>
      <br />
      <li>
        Ag&ecirc;ncias de
        <strong>Florian&oacute;polis e S&atilde;o Jos&eacute;</strong>, Posto de
        Atendimento da CASAN no
        <b
          >PROCON Estadual de Florian&oacute;polis e CIACs de
          Florian&oacute;polis</b
        >
        dos bairros Canasvieiras, Coloninha (Continente), Ingleses, Lagoa da
        Concei&ccedil;&atilde;o e Rio Tavares o atendimento dever&aacute; ser
        realizado exclusivamente atrav&eacute;s de agendamento;
      </li>
      <br />
      <li>
        <b>Demais Ag&ecirc;ncias</b>, o atendimento ser&aacute; exclusivamente
        por ordem de chegada com a retirada de senhas.
      </li>
      <br />
    </ul>
  </div>
  <div>
    <p>
      Lembramos que todos nossos serviços podem ser solicitados pelos nossos
      canais de atendimento a distância, via site
      <a
        routerLink="/servicos"
        class="text-color-secondary no-underline font-bold"
        >www.casan.com.br</a
      >.
    </p>
  </div>
  <div>
    <span><b>LEIA ANTES DE SEGUIR ADIANTE:</b></span>
    <ul>
      <li>
        Servi&ccedil;os emergenciais devem ser solicitados PREFERENCIALMENTE via
        Central de Atendimento&nbsp;115 e 0800 643 0195;
      </li>
      <li>
        Somente o usu&aacute;rio cadastrado ou representante legal poder&aacute;
        solicitar servi&ccedil;os na unidade e dever&aacute; ser comprovada
        atrav&eacute;s da documenta&ccedil;&atilde;o abaixo:
      </li>
    </ul>
    <ul>
      <ul>
        <li>
          Pessoa F&iacute;sica:
          <ul>
            <li>Documento completo com CPF e RG</li>
            <li>
              Procura&ccedil;&atilde;o caso n&atilde;o seja o
              titular/usu&aacute;rio cadastrado.
            </li>
          </ul>
        </li>
        <li>
          Empresas:
          <ul>
            <li>
              Contrato social ou &uacute;ltima altera&ccedil;&atilde;o
              contratual
            </li>
            <li>
              Documento completo com CPF e RG do s&oacute;cio administrador
            </li>
            <li>
              Procura&ccedil;&atilde;o (do s&oacute;cio administrador) caso
              n&atilde;o seja o s&oacute;cio administrador.
            </li>
          </ul>
        </li>
        <li>
          Entidades / Igrejas / Associa&ccedil;&otilde;es:
          <ul>
            <li>Estatuto</li>
            <li>Ata da &uacute;ltima elei&ccedil;&atilde;o</li>
            <li>Documento completo com CPF e RG do Presidente.</li>
            <li>
              Procura&ccedil;&atilde;o (do presidente) caso n&atilde;o seja o
              Presidente.
            </li>
          </ul>
        </li>
        <li>
          Condom&iacute;nios:
          <ul>
            <li>Ata da &uacute;ltima elei&ccedil;&atilde;o</li>
            <li>Documento completo com CPF e RG do s&iacute;ndico.</li>
            <li>
              Procura&ccedil;&atilde;o (do s&iacute;ndico) caso n&atilde;o seja
              o s&iacute;ndico.
            </li>
          </ul>
        </li>
        <li>
          Entidades do Governo:
          <ul>
            <li>Of&iacute;cio</li>
            <li>Documento completo com CPF e RG do nomeado.</li>
            <li>
              Procura&ccedil;&atilde;o (do nomeado atrav&eacute;s de ato
              oficial) caso n&atilde;o seja a pessoa nomeada oficialmente.
            </li>
          </ul>
        </li>
      </ul>
    </ul>
    <ul>
      <li>
        Antes de solicitar o&nbsp;agendamento,&nbsp;por favor, verifique se
        voc&ecirc; possui toda a documenta&ccedil;&atilde;o necess&aacute;ria
        para o atendimento de sua demanda&nbsp;<strong>
          <a
            href="http://www.casan.com.br/ckfinder/userfiles/CASAN - Serviços Comercias - Material Completo 2020 - Atalizado 07-05.pdf"
            target="_blank"
            class="text-color-secondary no-underline font-bold"
          >
            clicando aqui
          </a> </strong
        >;
      </li>
      <li>
        N&atilde;o &eacute; poss&iacute;vel o agendado para mais de um
        hor&aacute;rio para o mesmo CPF, no mesmo dia;
      </li>
    </ul>
  </div>
  <div>
    <span><b>Como fazer:</b></span>
    <ul>
      <li>
        Preencha os dados pessoais e o município onde será prestado o serviço;
      </li>
      <li>
        Selecione data e horário que deseja receber o atendimento. O sistema
        mostra todos os horários disponíveis, por município, para os próximos 30
        dias úteis. Caso não encontre um horário disponível pedimos que faça uma
        nova tentativa amanhã pela manhã;
      </li>
      <li>
        Após preencher todos os campos Clique em <strong>AGENDAR</strong>. O
        sistema exibirá o número do seu Protocolo de Agendamento, caso esse
        número não seja exibido o agendamento deverá ser refeito.
      </li>
    </ul>
  </div>

  <form
    [formGroup]="form"
    class="flex flex-column justify-content-middle"
    *ngIf="!agendado"
  >
    <div class="field grid">
      <label class="w-3 flex gap-2 mr-2 font-bold justify-content-end">
        Local que deseja ser atendido <span class="text-red-600">*</span>
      </label>
      <p-dropdown
        formControlName="local"
        [options]="locais"
        (onChange)="onSelectLocal()"
        optionLabel="nome"
        placeholder="Selecione o local"
        [dropdownIcon]="
          isLoadingLocais ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'
        "
      ></p-dropdown>
    </div>
    <div class="field grid">
      <label class="w-3 flex gap-2 mr-2 font-bold justify-content-end">
        Horários disponíveis<span class="text-red-600">*</span>
      </label>
      <p-dropdown
        formControlName="horario"
        [options]="horarios"
        placeholder="Selecione o horário"
        emptyMessage="Nenhum horário encontrado"
        [dropdownIcon]="
          isLoadingHorario ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'
        "
      >
        <ng-template let-item pTemplate="item">
          {{ item.horario | date : "dd/MM/yyyy H:mm" }}
        </ng-template>
        <ng-template pTemplate="selectedItem">
          {{ form.get("horario")?.value?.horario | date : "dd/MM/yyyy H:mm" }}
        </ng-template>
      </p-dropdown>
    </div>
    <div class="field grid">
      <label class="w-3 flex gap-2 mr-2 font-bold justify-content-end">
        Nome <span class="text-red-600">*</span>
      </label>
      <input
        pInputText
        autocomplete="off"
        maxlength="256"
        class="w-4"
        formControlName="nome"
      />
    </div>
    <div class="field grid">
      <label
        class="w-3 flex gap-2 mr-2 font-bold justify-content-end"
        for="telefone"
      >
        Celular <span class="text-red-600">*</span>
      </label>
      <p-inputMask
        mask="(99) 99999-9999"
        autocomplete="off"
        inputId="telefone"
        formControlName="telefone"
      />
    </div>
    <div class="field grid">
      <label
        class="w-3 flex gap-2 mr-2 font-bold justify-content-end"
        for="cpf"
      >
        CPF <span class="text-red-600">*</span>
      </label>
      <p-inputMask
        autocomplete="off"
        mask="999.999.999-99"
        inputId="cpf"
        formControlName="cpf"
      />
    </div>

    <p-button
      [loading]="isSending"
      styleClass="w-full mb-4"
      label="Agendar"
      [disabled]="form.invalid || form.disabled"
      (onClick)="onSubmit()"
    ></p-button>
  </form>
  <hr />
  <div *ngIf="agendado">
    <div style="text-align: center">
      <h2>Agendamento Realizado com Sucesso</h2>
      <h4>
        Número do Protocolo de Agendamento:
        {{ agendado.protocolo }}
      </h4>
      <p>
        <strong
          >Pedimos que compareça na agência solicitada na data e horário
          abaixo:</strong
        >
      </p>
      <p>
        <strong>{{ agendado.localNome }}</strong>
      </p>
      <p>
        <strong>{{
          agendado.dataAgendamento | date : "dd/MM/yyyy hh:mm"
        }}</strong>
      </p>
      <p>
        <a
          href="https://www.casan.com.br/menu-conteudo/index/url/enderecos-e-horarios-das-agencias"
          target="_blank"
          >Clique aqui e verifique o endereço da agência selecionada</a
        >
      </p>
    </div>
    <hr />
    <div
      style="text-align: left; margin-top: 15px; margin-left: 0px !important"
    >
      <p>
        <strong
          >Informamos que os atendimentos no Município de Chapecó serão
          realizados conforme abaixo:</strong
        >
      </p>
      <ul>
        <li>Chapecó: Unidade do Centro - Avenida Fernando Machado, 35.</li>
      </ul>
      <div>
        <br />
        <div class="row" style="text-align: left; margin-left: 0px !important">
          <p><strong>INFORMAÇÕES IMPORTANTES:</strong></p>
          <ul>
            <li>
              Antes de se deslocar para a unidade de atendimento verifique a
              documentação obrigatória para sua solicitação
              <b
                ><a
                  href="https://www.casan.com.br/ckfinder/userfiles/CASAN - Serviços Comercias - Material Completo 2020 - Atalizado 07-05.pdf"
                  target="_blank"
                  >clicando aqui</a
                ></b
              >;
            </li>
            <li>
              O acesso ao local de atendimento será permitido somente:
              <ul>
                <li>
                  No horário agendado com tolerância de 15 minutos de atraso.
                  Após esse prazo o atendimento será cancelado e será necessário
                  um novo agendamento;
                </li>
                <li>
                  Ao responsável pelo agendamento e de mais um acompanhante;
                </li>
                <li>
                  Com a apresentação de documento com foto e o "<u
                    >Número do Protocolo de Agendamento</u
                  >", informado acima;
                </li>
                <li>Com a utilização de máscaras de proteção.</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
